import React, { Fragment, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { ChevronUpDownIcon } from '@heroicons/react/20/solid';

const roles = [
  { name: 'Хаммаси' },
  { name: 'Номланиши' },
];

export default function ListOfDisponserList() {
  const [selectedRole, setSelectedRole] = useState(roles[0]);

  return (
    <div className="z-[1] w-full sm:w-44">
      <Listbox value={selectedRole} onChange={setSelectedRole}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-default rounded-lg border border-slate-200 bg-white py-1 pl-3 pr-9 text-left text-sm text-slate-700 focus:outline-none focus-visible:border-[#1D2C7B] focus-visible:ring-2 focus-visible:ring-[#1D2C7B]/20">
            <span className="block truncate">{selectedRole.name}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon className="h-4 w-4 text-slate-400" aria-hidden="true" />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-20 mt-1.5 max-h-60 w-full overflow-auto rounded-lg border border-slate-200 bg-white py-1 text-sm focus:outline-none">
              {roles.map((role, roleIdx) => (
                <Listbox.Option
                  key={roleIdx}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-9 pr-3 ${
                      active ? 'bg-slate-100 text-[#1D2C7B]' : 'text-slate-700'
                    }`
                  }
                  value={role}
                >
                  {({ selected }) => (
                    <>
                      <span className={`block truncate ${selected ? 'font-medium text-[#1D2C7B]' : 'font-normal'}`}>
                        {role.name}
                      </span>
                      {selected && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-[#1D2C7B]">
                          <CheckIcon className="h-4 w-4" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
